"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER = void 0;
exports.parseCombinedAtcBuyNowButtonText = parseCombinedAtcBuyNowButtonText;
exports.isValidCombinedAtcBuyNowButtonText = isValidCombinedAtcBuyNowButtonText;
exports.combineInlineCtaButtonText = combineInlineCtaButtonText;
exports.splitInlineCtaButtonText = splitInlineCtaButtonText;
exports.resolveInlineCtaButtonText = resolveInlineCtaButtonText;
const apiTypes_1 = require("../apiTypes");
/** Delimiter for {@link LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW} `buttonText` (ATC|BN). */
exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER = '|';
/**
 * Parses `buttonText` for ADD_TO_CART_AND_BUY_NOW: first part before the first `|`
 * is Add to Cart; remainder (may include `|`) is Buy Now. Falls back to default
 * single-button labels when missing or malformed.
 */
function parseCombinedAtcBuyNowButtonText(buttonText) {
    var _a;
    const defaultAtc = apiTypes_1.DEFAULT_BUTTON_TEXT_BY_TYPE[apiTypes_1.LP_BUTTON_TYPE.ADD_TO_CART];
    const defaultBn = apiTypes_1.DEFAULT_BUTTON_TEXT_BY_TYPE[apiTypes_1.LP_BUTTON_TYPE.BUY_NOW];
    const trimmed = (_a = buttonText === null || buttonText === void 0 ? void 0 : buttonText.trim()) !== null && _a !== void 0 ? _a : '';
    if (!trimmed) {
        return { addToCart: defaultAtc, buyNow: defaultBn };
    }
    const i = trimmed.indexOf(exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER);
    if (i === -1) {
        return { addToCart: defaultAtc, buyNow: defaultBn };
    }
    const addToCart = trimmed.slice(0, i).trim();
    const buyNow = trimmed.slice(i + 1).trim();
    return {
        addToCart: addToCart || defaultAtc,
        buyNow: buyNow || defaultBn,
    };
}
/** Admin/save validation: both sides of the first `|` must be non-empty (after trim). */
function isValidCombinedAtcBuyNowButtonText(buttonText) {
    const t = buttonText.trim();
    const i = t.indexOf(exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER);
    if (i <= 0)
        return false;
    const addToCart = t.slice(0, i).trim();
    const buyNow = t.slice(i + 1).trim();
    return addToCart.length > 0 && buyNow.length > 0;
}
/* --- Inline PDP combined `buttonText` (ATC|BN), with `|`/`\` escaped so a literal pipe in
   either label survives the round-trip. Separate from the floating-button parse above. --- */
function escapeButtonTextSegment(s) {
    return s.replace(/\\/g, '\\\\').replace(/\|/g, '\\|');
}
function unescapeButtonTextSegment(s) {
    return s.replace(/\\(.)/g, '$1');
}
/** Index of the first unescaped delimiter, or -1. */
function firstUnescapedDelimiterIndex(s) {
    for (let i = 0; i < s.length; i++) {
        if (s[i] === '\\') {
            i++; // skip the escaped character
            continue;
        }
        if (s[i] === exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER)
            return i;
    }
    return -1;
}
/** Join two labels into the combined ATC|BN format, escaping any literal delimiter. */
function combineInlineCtaButtonText(addToCart, buyNow) {
    return `${escapeButtonTextSegment(addToCart)}${exports.COMBINED_ATC_BN_BUTTON_TEXT_DELIMITER}${escapeButtonTextSegment(buyNow)}`;
}
/** Split a combined ATC|BN string into its (unescaped) sides, or null when it isn't combined. */
function splitInlineCtaButtonText(buttonText) {
    const raw = buttonText !== null && buttonText !== void 0 ? buttonText : '';
    const i = firstUnescapedDelimiterIndex(raw);
    if (i === -1)
        return null;
    return {
        addToCart: unescapeButtonTextSegment(raw.slice(0, i)),
        buyNow: unescapeButtonTextSegment(raw.slice(i + 1)),
    };
}
/** Resolve an inline PDP's CTA label(s) from its single `buttonText` (undefined → use the action's default). */
function resolveInlineCtaButtonText(opts) {
    const { actions, buttonText } = opts;
    const bothActions = actions.includes(apiTypes_1.INLINE_CTA_ACTION.ADD_TO_CART) &&
        actions.includes(apiTypes_1.INLINE_CTA_ACTION.BUY_NOW);
    if (!bothActions) {
        const trimmed = (buttonText === null || buttonText === void 0 ? void 0 : buttonText.trim()) || undefined;
        return { addToCart: trimmed, buyNow: trimmed };
    }
    const defaultBn = apiTypes_1.DEFAULT_BUTTON_TEXT_BY_TYPE[apiTypes_1.LP_BUTTON_TYPE.BUY_NOW];
    const split = splitInlineCtaButtonText(buttonText);
    if (!split) {
        // No delimiter: a lone label applies to Add to Cart; Buy Now uses its default.
        return { addToCart: (buttonText === null || buttonText === void 0 ? void 0 : buttonText.trim()) || undefined, buyNow: defaultBn };
    }
    const defaultAtc = apiTypes_1.DEFAULT_BUTTON_TEXT_BY_TYPE[apiTypes_1.LP_BUTTON_TYPE.ADD_TO_CART];
    return {
        addToCart: split.addToCart.trim() || defaultAtc,
        buyNow: split.buyNow.trim() || defaultBn,
    };
}
